import { render, staticRenderFns } from "./customersService.vue?vue&type=template&id=6b40cf8f&scoped=true"
import script from "./customersService.vue?vue&type=script&lang=js"
export * from "./customersService.vue?vue&type=script&lang=js"
import style0 from "./customersService.vue?vue&type=style&index=0&id=6b40cf8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b40cf8f",
  null
  
)

export default component.exports